module.exports = __webpack_public_path__ + "img/modelDefalutScreen.96021a6e.png";